import { Provider } from "./provider/Provider";

const SliderService = {
  sliderListesi: () => {
    return Provider({
      methodName: "Module/Slider/SliderListesi",
    });
  },
  sliderEkle: ({ sliderAdi, sliderAciklamasi, gecisler }) => {
    return Provider({
      sliderAdi,
      sliderAciklamasi,
      gecisler,
      methodName: "Module/Slider/SliderEkle",
    });
  },
  sliderGuncelle: ({ sliderCode, sliderAdi, sliderAciklamasi, gecisler }) => {
    return Provider({
      sliderCode,
      sliderAdi,
      sliderAciklamasi,
      gecisler,
      methodName: "Module/Slider/sliderGuncelle",
    });
  },
  sliderKaldir: (sliderCode) => {
    return Provider({
      sliderCode,
      methodName: "Module/Slider/SliderKaldir",
    });
  },
  sliderDetay: (sliderCode) => {
    return Provider({
      sliderCode,
      methodName: "Module/Slider/SliderDetay",
    });
  },
};

export default SliderService;
